import { Component, OnInit } from '@angular/core';
import { FormButton } from '../../../core/components/form-field-button/form-field-button.component';
import { Grid } from '../../../core/components/grid/grid.model';
import { GridOptions } from '../../../core/components/grid/grid.types';
import { DataTaskService } from '../../../core/services/data-task.service';

@Component({
  selector: 'tt-paperless-po',
  templateUrl: './paperless-po.component.html',
  styleUrls: ['./paperless-po.component.css']
})
export class PaperlessPoComponent implements OnInit {
    public setting?: Setting;

    public grid?: GridOptions;

    public orderSearchButtons: FormButton[] = [{ id: 'search', type: 'primary', icon: 'fas fa-search', onClick: () => this.searchOrders() }];

    public productSearchButtons: FormButton[] = [{ id: 'search', type: 'primary', icon: 'fas fa-search', onClick: () => this.searchProductOrders() }];

    constructor(private datatask: DataTaskService) {

    }

    private async loadSetting() {
        this.setting = (await this.datatask.Post(492))[0];
    }

    private loadGrid() {
        if (!this.setting) return;

        if (!this.grid) {
            this.grid = new Grid()
                .setRememberId(this.setting.view_id)
                .setLoadDataFunction({
                    method: this.setting.p2_datatask_keyno,
                    parameters: () => this.setting
                })
                .setKendoConfig({ height: '100%' })
                .setToolbar({ wrapping: true });
        } else {
            this.grid?.gridfunc?.read();
        }
    }

    public searchOrders() {
        this.loadGrid();
    }

    public searchProductOrders() {
        this.loadGrid();
    }

    public onChanged(_: string, id: keyof Setting) {
        if (!this.setting) return;

        switch (id) {
            case 'ordersearch':
            case 'prodsearch':
                if (this.setting[id] === '') this.loadGrid();
                break;
            default:
                break;
        }
    }

    private async init() {
        await this.loadSetting();
        this.loadGrid();
    }

    ngOnInit() {
        this.init();
    }
}

interface Setting {
    operation_id: string;
    stockplace_name: string;
    operation_name: string;
    stockplace_id: string;
    ordersearch: string;
    prodsearch: string;
    p2_datatask_keyno: number;
    view_id: string;
}
